export default function stringMaxLengthFilter (string, maxLength) {
  if (!string?.length) return string

  if (string.length <= maxLength) {
    return string
  } else {
    return string.toString().substring(0, maxLength - 3).trim() + '...'
  }
}
